import { MonthsOfTheYear } from "utils/choices";

export const healthInsuranceId = record => `${record.year}/${record.month}`;

export const getMonthName = monthId => MonthsOfTheYear.find(m => m.id === monthId)?.name;